import { Reducer } from 'redux';
import { ACTION, ValidationChange } from './action-types';
import { reducer as simpleFormReducer, INITIAL_SIMPLEFORM_STATE } from 'app/infrastructure/simple-form/reducers';
import { STATE } from 'app/constants';
import { SimpleFormAreaState } from 'app/infrastructure/simple-form/types';
import { TextCollection } from 'app/types-shared';

export interface ProfileState {
  texts: TextCollection;
  simpleForm?: SimpleFormAreaState;
  validation: any;
}

export const INITIAL_SETTINGS_STATE: any = {
  validation: {},
  ...INITIAL_SIMPLEFORM_STATE
};

export const reducers: { [indexer: string]: Reducer<ProfileState> } = {

  /**
   * Run when a component recieve validation data
   */
  [ACTION.VALIDATION_CHANGE]: (state: ProfileState, action: ValidationChange): ProfileState => {

    return {
      ...state,
      validation: action.validation
    };
  }

};

export const reducer: Reducer<ProfileState> = (state: ProfileState = INITIAL_SETTINGS_STATE, action: any) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || simpleFormReducer(STATE.userSettings)(state, action);
};
